import BrandIsManaged from './BrandIsManaged.Container';

export default BrandIsManaged;
